

































































































































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
    import { BACKEND_URL } from '@/helpers/constants';
    import { buildDocumentUrl } from '@/helpers/document';
    import Booking from '@/models/Booking';
    import get from 'lodash/get';
    import LotTable from '@/components/prescriber/LotTable.vue';
    import { saveAs } from 'file-saver';
    import axios from 'axios';
    import ProgramDocument from '@/models/ProgramDocument';
    import {
        documentTypes,
        formatDocumentType,
        formatDocumentTypeFileName,
        DOCUMENT_TYPE,
    } from '@/data/documentTypes';
import {
  getBookingDocumentPrescriber,
  getBookingDocumentAdmin,
  getProgramArchiveAdmin,
  getProgramArchiveByTypeAdmin,
  getProgramArchivePrescriber,
  getProgramArchiveByTypePrescriber,
  postBookingDocumentAdmin,
  deleteBookingDocumentAdmin, postBookingDocumentPrescriber, deleteBookingDocumentPrescriber, patchBooking,
} from '../../api/api';
    import snakeCase from 'lodash/snakeCase';
    import {
        bookingDocumentsTypes,
        formatBookingDocumentsTypes,
        formatBookingDocumentsTypesFileName,
    } from '@/data/bookingDocumentsTypes';
    import DownloadLink from '@/components/prescriber/DownloadLink.vue';
    import PdfThumbnail from '@/components/prescriber/PdfThumbnail.vue';
    import difference from 'lodash/difference';
    import moment from 'moment';
    import UploadComponent, {
      InputFile,
    } from '@/components/common/UploadComponent.vue';
    import AuthModule from "@/store/AuthModule";

    interface DocumentsByType {
        [index: string]: ProgramDocument[];
    }

    interface Loaders {
      [index: string]: boolean;
    }

    interface Files {
      [index: string]: InputFile | null;
    }

    @Component({
        components: {
            DownloadLink,
            UploadComponent,
            PdfThumbnail,
        },
        filters: {
            formatDocumentType,
            formatDate: (date: string) => {
              if (date == null){
                return 'Non renseigné'
              }
              return moment(date).format('L');
            },
        },
    })
    export default class BookingDocuments extends Vue {
        @Prop() booking!: Booking | undefined;
        @Prop({ type: Boolean, default: false }) asAdmin!: boolean;
        BACKEND_URL = BACKEND_URL;
        itsPrescriber: boolean = AuthModule.roles.includes("ROLE_PRESCRIBER")

        // enregistre la modification de la date de paiement honoraire
        datePaiementHono: any = null;
        @Watch('datePaiementHono')
        async onDatePaiementHono() {
          let patch: Booking = {};
          patch = { date_payment_hono : this.datePaiementHono };
          const { data } = await patchBooking(this.booking!.id!, patch);
        }

        mounted() {
          if (!this.booking) {
            return;
          }
          if (this.booking.contract_counter_signed) {
            this.files.contractCounterSigned = {
              filename: `${this.booking.contract_counter_signed.name}.${this.booking.contract_counter_signed.extension}`,
              data: '',
            }
          }
          // bind les date paiement/acte vente dans les input date
          if(this.booking.date_payment_hono){
            this.datePaiementHono = this.booking.date_payment_hono!.toString().substr(0,10);
          }

          this.loadBookingDocPreviews();
        }

        beforeDestroy() {
          Object.values(this.bookingDocPreviewUrls).forEach(url => URL.revokeObjectURL(url));
        }

        // Ces documents sont stockés en privé côté backend (var/private/uploads) : ils
        // ne sont jamais accessibles via une URL statique, il faut passer par l'API authentifiée.
        bookingDocPreviewUrls: { [index: string]: string } = {};

        // Seuls le PDF et les images se prévisualisent correctement dans un <iframe>/<img>.
        // Une extension inconnue ou absente (URL sans extension, métadonnée manquante) ne veut
        // pas dire "pas d'archive" : le fichier réel peut très bien être un zip/rar. On traite
        // donc par défaut toute extension non reconnue comme une archive, pour ne jamais tenter
        // de la charger dans un iframe et déclencher un téléchargement forcé côté navigateur.
        isArchiveExtension(extension: string | null | undefined): boolean {
          const previewable = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
          return !previewable.includes((extension || '').toLowerCase());
        }

        async loadBookingDocPreviews() {
          const booking = this.booking;
          if (!booking || !booking.id) {
            return;
          }
          const bookingId = booking.id;

          const fn = this.asAdmin ? getBookingDocumentAdmin : getBookingDocumentPrescriber;
          const items = [...this.bookingDocumentsTypesArr, ...this.plugimmoDocumentsTypesArr];

          await Promise.all(items.map(async item => {
            const doc = (booking as any)[item.valueSnake];
            if (!doc || this.isArchiveExtension(doc.extension)) {
              return;
            }
            try {
              const { data } = await fn(bookingId, item.value);
              this.$set(this.bookingDocPreviewUrls, item.valueSnake, URL.createObjectURL(data));
            } catch (e) {
              // pas de preview possible, la carte retombe sur l'icône générique
            }
          }));
        }

        async openBookingDocument(type: string, valueSnake: string) {
          if (this.bookingDocPreviewUrls[valueSnake]) {
            this.openInTab(this.bookingDocPreviewUrls[valueSnake]);
            return;
          }

          if (!this.booking || !this.booking.id) {
            return;
          }

          const fn = this.asAdmin ? getBookingDocumentAdmin : getBookingDocumentPrescriber;
          const { data } = await fn(this.booking.id, type);
          const url = URL.createObjectURL(data);
          this.$set(this.bookingDocPreviewUrls, valueSnake, url);
          this.openInTab(url);
        }

      loaders: Loaders = {
        contractCounterSigned: false,
      };

      files: Files = {
        contractCounterSigned: null,
      };

      async onFile(file: InputFile, type: string) {
        if (!this.booking || !this.booking.id) {
          return;
        }

        try {
          this.loaders[type] = true;
          let data = null;
          if(this.asAdmin) {
            let { data } = await postBookingDocumentAdmin(
                this.booking.id,
                type,
                {
                  file_name: file.filename,
                  document: file.data,
                }
            );

            if(this.booking.progression == 'to_deal') {
                document.location.reload();
            }

          }else{
            let { data } = await postBookingDocumentPrescriber(
                this.booking.id,
                type,
                {
                  file_name: file.filename,
                  document: file.data,
                }
            );
          }

          this.$emit('booking', data);
          this.showSuccess('Fichier ajouté avec succès');
            } catch (e) {
                const err = e as any;
                // on réinitialise le fichier côté UI
                this.files[type] = null;

                let userMessage = "Une erreur est survenue lors de l'envoi.";

                if (err.response && err.response.status) {
                const status = err.response.status;
                const serverMsg = err.response.data && err.response.data.message;

                if (status === 400) {
                    userMessage = 'Requête invalide : fichier corrompu ou paramètres incorrects.';
                } else if (status === 413) {
                    userMessage = 'Le fichier est trop volumineux (taille maxi dépassée).';
                } else if (status === 415) {
                    userMessage = "Format non supporté. Merci d'envoyer uniquement du PDF ou ZIP.";
                } else if (status === 500) {
                    userMessage = 'Erreur serveur. Merci de réessayer plus tard.';
                } else if (serverMsg) {
                    userMessage = `Erreur ${status} : ${serverMsg}`;
                } else {
                    userMessage = `Erreur inconnue (${status}).`;
                }

                } else if (err.request) {
                userMessage = 'Pas de réponse du serveur ; vérifiez votre connexion.';
                } else if (err.message) {
                userMessage = err.message;
                }

                this.showError(err, userMessage);
            } finally {
                this.loaders[type] = false;
            }
            }




      async onDelete(type: string) {
        if (!this.booking || !this.booking.id) {
          return;
        }
        if(this.asAdmin) {
          deleteBookingDocumentAdmin(this.booking.id, type, '(AUCUN)')
              .then(() => {
                this.showSuccess('Document supprimé');
                this.files[type] = null;
              })
              .catch(e => {
                this.showError(e, 'Erreur lors de la supression du document');
              });
        } else {
          deleteBookingDocumentPrescriber(this.booking.id, type)
              .then(() => {
                this.showSuccess('Document supprimé');
                this.files[type] = null;
              })
              .catch(e => {
                this.showError(e, 'Erreur lors de la suppression du document');
              });
        }
      }

      showSuccess(message: string) {
        const $vs = (this as any).$vs;
        $vs.notify({
          color: 'success',
          position: 'top-right',
          title: 'Succès',
          text: message,
        });
      }

      showError(error: Error, defaultMessage: string) {
        const message = get(error, 'response.data.message', defaultMessage);

        const $vs = (this as any).$vs;
        $vs.notify({
          color: 'danger',
          position: 'top-right',
          title: 'Erreur',
          text: message,
        });
      }


      get program() {
            if (!this.booking || !this.booking.lot || !this.booking.lot.program) {
                return null;
            }

            return this.booking.lot.program;
        }

        openInTab(url: string) {
            window.open(url, '_blank', 'noopener');
        }

        async downloadHousingPlan() {
            if (!this.booking || !this.booking.lot || !this.booking.lot.plan) {
                return;
            }

            const plan = this.booking.lot.plan;
            const url = buildDocumentUrl(BACKEND_URL, plan);
            const fileName = url.substring(url.lastIndexOf('/') + 1);

            const { data } = await axios.get(url, {
                responseType: 'blob',
            });
            saveAs(data, fileName);
        }

        async download(type: string) {
            const obj: DocumentsByType = {};
            obj[type] = this.docsByType[type];

            if (!this.program || !this.program.id) {
                return;
            }

            const fn = this.asAdmin
                ? getProgramArchiveByTypeAdmin
                : getProgramArchiveByTypePrescriber;

            const { data } = await fn(this.program.id, type);
            saveAs(
                data,
                `${formatDocumentTypeFileName(
                    this.booking && this.booking.code ? this.booking.code : '',
                    type
                )}.${data.type.endsWith('zip') ? 'zip' : 'pdf'}`
            );
        }

        async downloadAll() {
            if (!this.program || !this.program.id) {
                return;
            }

            const fn = this.asAdmin
                ? getProgramArchiveAdmin
                : getProgramArchivePrescriber;

            const { data } = await fn(this.program.id);
            saveAs(
                data,
                `${this.booking && this.booking.code ? this.booking.code : ''
                }_Tous_documents_${moment().format('DDMMYYYY')}`
            );
        }

        get leftDocuments() {
            return [
                'documents_annual_charge',
                'documents_notice',
                'documents_booking_contract',
                'documents_works_contract',
                'documents_commercial_brochure',
                'documents_management_brochure',
            ];
        }

        get rightDocuments() {
            return [
                'documents_parking_plan',
                'documents_floor_plan',
                'documents_rental_agreement',
                'documents_general_assembly',
            ];
        }

        get docsByType() {
            const docs = Object.keys(documentTypes).reduce<DocumentsByType>(
                (accu, key) => {
                    if (
                        this.booking &&
                        this.booking.lot &&
                        this.booking.lot.program &&
                        this.booking.lot.program.documents
                    ) {
                        accu[key] = this.booking.lot.program.documents.filter(
                            doc => doc.type === key
                        );
                    } else {
                        accu[key] = [];
                    }

                    return accu;
                },
                {}
            );

            return docs;
        }

        get docsByTypeLength() {
            return Object.keys(this.docsByType).reduce((accu, key) => {
                accu += this.docsByType[key].length;
                return accu;
            }, 0);
        }

        /**
         * Documents relatifs à la réservation
         */
        async downloadBookingDocument(type: string) {
            if (!this.booking || !this.booking.id) {
                return;
            }

            const fn = this.asAdmin
                ? getBookingDocumentAdmin
                : getBookingDocumentPrescriber;

            const { data } = await fn(this.booking.id, type);

            saveAs(
                data,
                `${formatBookingDocumentsTypesFileName(
                    this.booking.code ? this.booking.code : '',
                    type
                )}.${data.type.endsWith('zip') ? 'zip' : 'pdf'}`
            );
        }

        get bookingDocumentsTypesArr() {
            const _types = Object.keys(bookingDocumentsTypes);
            const types = difference(_types, ['transferProof', 'invoiceDocument', 'promoterDirectInvoice', 'invoiceRearMargin']);

            return types.map(key => ({
                text: formatBookingDocumentsTypes(key),
                value: key,
                valueSnake: snakeCase(key),
            }));
        }

        get plugimmoDocumentsTypesArr() {
            const types = ['transferProof', 'invoiceDocument', 'promoterDirectInvoice'];

            return types.map(key => ({
                text: formatBookingDocumentsTypes(key),
                value: key,
                valueSnake: snakeCase(key),
            }));
        }
    }
